import React, { createContext, useReducer } from 'react'
const actionTypes = {
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL'
}
// Initialize a context
const Context = createContext('app-modal')

const { Provider } = Context

const defaultState = {
  toggled: false,
  Content: null,
  Title: null
}

const showModalAction = payload => ({
  type: actionTypes.SHOW_MODAL,
  payload: { toggled: true, ...payload }
})

const hideModalAction = () => ({
  type: actionTypes.HIDE_MODAL,
  payload: { toggled: false, Content: null, Title: null }
})

const StateProvider = props => {
  const [items = defaultState, dispatch] = useReducer(
    (state = defaultState, action) => {
      switch (action.type) {
        case actionTypes.SHOW_MODAL:
          return {
            ...state,
            ...action.payload
          }

        case actionTypes.HIDE_MODAL:
          return {
            ...state,
            ...action.payload
          }

        default:
          return state
      }
    }
  )

  return (
    <Provider
      {...props}
      value={{
        state: items,
        dispatch: {
          showModal: ({ Content, Title, size }) => {
            dispatch(showModalAction({ Content, Title, size }))
          },
          hideModal: () => {
            dispatch(hideModalAction())
          }
        }
      }}
    />
  )
}

export { Context as ModalContext, StateProvider as default }
